import $ from "jquery";

export interface WordpressVariables {
  ajaxUrl: string;
  nonce: string | false;
}

export function wordpress(): WordpressVariables {
  // @ts-ignore
  return window.wp_vars || ({} as WordpressVariables);
}

function wordpressAjaxAction(action: string, query?: object): string {
  const url = new URL(wordpress().ajaxUrl);

  url.searchParams.set("action", action);

  if (query) {
    for (let parameter in query) {
      url.searchParams.set(parameter, query[parameter]);
    }
  }

  return url.toString();
}

async function request(options: {
  method: string;
  action: string;
  headers?: HeadersInit;
  body?: any;
  query?: object;
}): Promise<Response> {
  let url = wordpressAjaxAction(options.action, options.query);

  if (options.method == "GET" && typeof options.body === "object") {
    const urlObject = new URL(url);

    for (let param in options.body) {
      urlObject.searchParams.set(param, options.body[param]);
    }

    url = urlObject.toString();
    options.body = null;
  }

  return await fetch(url, {
    method: options.method,
    mode: "cors",
    cache: "no-cache",
    credentials: "same-origin",
    headers: options.headers,
    redirect: "follow",
    referrerPolicy: "no-referrer",
    body: options.body,
  });
}

export async function jsonRequest(
  method: string,
  action: string,
  data?: any,
  query?: object
): Promise<Response> {
  const options = {
    method,
    action,
    headers: {
      "Content-Type": "application/json",
    },
    query,
  };

  if (data) {
    options["body"] = JSON.stringify(data);
  }

  return await request(options);
}

export async function formRequest(
  method: string,
  action: string,
  data: FormData
): Promise<Response> {
  return await request({
    method,
    action,
    body: data,
  });
}

export async function requestStatusMessage(
  response: Response
): Promise<string> {
  const responseJson = await response.json();

  if (Object.keys(responseJson).includes("status")) {
    return responseJson.status;
  }

  if (Object.keys(responseJson).includes("error")) {
    return responseJson.error.join("\n");
  }

  return "";
}
